module.exports = __webpack_public_path__ + "static/media/rectangularconcretesection.57831a24.svg";